import { render, staticRenderFns } from "./VerificationPending.vue?vue&type=template&id=b74620a2&scoped=true&"
import script from "./VerificationPending.vue?vue&type=script&lang=js&"
export * from "./VerificationPending.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPending.vue?vue&type=style&index=0&id=b74620a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74620a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b74620a2')) {
      api.createRecord('b74620a2', component.options)
    } else {
      api.reload('b74620a2', component.options)
    }
    module.hot.accept("./VerificationPending.vue?vue&type=template&id=b74620a2&scoped=true&", function () {
      api.rerender('b74620a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/VerificationPending.vue"
export default component.exports